import React from 'react'
import PropTypes from 'prop-types'
import { Text, Margin } from 'shared/components'
import { MobileBeneficiaryFilters } from '../mobileBeneficiaryFilters'

import * as styles from './styles'

const MobileHeaderComponent = ({
	title = 'Beneficiaries',
	activeTab,
	categories,
	onTabChange,
}) => {
	return (
		<div css={styles.header}>
			<div css={styles.headerContent}>
				<Margin bottom={3}>
					<div css={styles.titleContainer}>
						<img
							src="./img/inwin-tiny-white-logo.png"
							alt="InWin Logo"
							css={styles.logo}
						/>
						<Text size={20} bold white css={styles.title}>
							{title}
						</Text>
					</div>
				</Margin>

				<MobileBeneficiaryFilters
					activeTab={activeTab}
					categories={categories}
					onTabChange={onTabChange}
				/>
			</div>
		</div>
	)
}

MobileHeaderComponent.propTypes = {
	title: PropTypes.string,
	activeTab: PropTypes.string.isRequired,
	categories: PropTypes.arrayOf(PropTypes.shape({
		description: PropTypes.string.isRequired,
	})).isRequired,
	onTabChange: PropTypes.func.isRequired,
}

export default MobileHeaderComponent 